import { render, staticRenderFns } from "./FeFrancisco.vue?vue&type=template&id=3632654a&"
import script from "./FeFrancisco.vue?vue&type=script&lang=js&"
export * from "./FeFrancisco.vue?vue&type=script&lang=js&"
import style0 from "./FeFrancisco.vue?vue&type=style&index=0&id=3632654a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports